import React, { Component } from "react";
import $ from "jquery";
import aidao from "./../../assets/images/Aidao.svg";
import ether from "./../../assets/images/Ethereum.svg";
import cobinhood from "./../../assets/images/cobinhood.svg";
import cybermiles from "./../../assets/images/cybermiles.svg";
import wandx from "./../../assets/images/wandx.svg";
import credits from "./../../assets/images/credit.svg";
import ncash from "./../../assets/images/ncash.svg";
import xinfin from "./../../assets/images/xinfin.svg";
import xyo from "./../../assets/images/xyo.svg";
import incodium from "./../../assets/images/inco.svg";
import fuzex from "./../../assets/images/fuzex.svg";
import autonio from "./../../assets/images/auto.svg";
import essentia from "./../../assets/images/ess.svg";
import dicet from "./../../assets/images/dicet1.svg";
import moneynet from "./../../assets/images/mon.svg";
import nbr from "./../../assets/images/nbr.svg";
import bitrewards from "./../../assets/images/bit.svg";
import singularitynet from "./../../assets/images/singularity.svg";
import stacs from "./../../assets/images/stacs-logo.svg";
import orbs from "./../../assets/images/orbs-logo.svg";
import kick from "./../../assets/images/kick.png";

import { Link } from "react-router-dom";

export default class TokenPage extends Component {
  render() {
    const precision = 3;
    var cobinhoodbalance = parseFloat(window.cobinhoodbalance).toFixed(precision);
    var wandxbalance = parseFloat(window.wandxbalance).toFixed(precision);
    var xyobalance = parseFloat(window.xyobalance).toFixed(precision);
    var nbrbalance = parseFloat(window.nbrbalance).toFixed(precision);
    var bitrewardsbalance = parseFloat(window.bitrewardsbalance).toFixed(precision);
    var creditsbalance = parseFloat(window.creditsbalance).toFixed(precision);
    var ncashbalance = parseFloat(window.ncashbalance).toFixed(precision);
    var essentiabalance = parseFloat(window.essentiabalance).toFixed(precision);
    var singularitynetbalance = parseFloat(window.agibalance).toFixed(precision);
    var incodiumbalance = parseFloat(window.incodiumbalance).toFixed(precision);
    var autoniobalance = parseFloat(window.autoniobalance).toFixed(precision);
    var dicebalance = parseFloat(window.dicebalance).toFixed(precision);
    var moneynetbalance = parseFloat(window.moneynetbalance).toFixed(precision);
    var stacsbalance = parseFloat(window.stacsbalance).toFixed(precision);
    const orbsbalance = parseFloat(window.orbsbalance).toFixed(precision);
    const kickbalance = parseFloat(window.kickbalance).toFixed(precision);

    const noprice = "No Price Available";

    const kyc_level = window.kyc;
    const belongs  = window.belongs;
    if (kyc_level < 3 && belongs === 'Mr.Cho') {
      return (
        <div>
        <div class="row">
          <div class="kyc-command">
          Please do KYC First in order to view this page.
          We require everyone to pass identification (KYC) in order to receive and withdraw airdrop tokens.
          Please do so before December 25, 2021 in order to further access token page.
          However, You do not need to pass KYC to send and receive ETH or AiDAO Token
          </div>
          <div class="kyc-command">
          이 페이지를 보려면 먼저 KYC를 수행하십시오.
           에어드롭 토큰을 받고 출금하기 위해서는 모든 사람이 신분증(KYC)을 통과해야 합니다.
           이 페이지에 액세스하려면 2021년 12월 25일 이전에 그렇게 하십시오.
           그러나 ETH 또는 AiDAO 토큰을 보내고 받기 위해 KYC를 통과할 필요가 없습니다.
           </div>

           <div class="kyc-command">
           If you have submitted KYC before but did not pass the KYC, you can now re-submit your documents.
           </div>
           <div class="kyc-command">
           이전에 KYC를 제출했지만 KYC를 통과하지 못한 경우 이제 문서를 다시 제출할 수 있습니다.
           </div>
           <Link  class="kyc-command" to={{ pathname: "/dashboard/account" }}>
             Go to Account Page to do KYC
           </Link>
           <Link  class="kyc-command" to={{ pathname: "/dashboard/account" }}>
             계정 페이지로 이동하여 KYC 수행
           </Link>
        </div>
        </div>
      )
    }

    return (
      <div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="cobinhood">
              <Link to={{ pathname: "/dashboard/cobinhood" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={cobinhood}
                      alt="cobinhood icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {cobinhoodbalance} COB
                  </h3>
                </div>
              </Link>
            </div>
          </div>


          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="wandx">
              <Link to={{ pathname: "/dashboard/wandx" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img src={wandx} alt="wandx icon" class="token64 m-b-10" />
                    <div class="word-break" />
                    {wandxbalance} WAND
                  </h3>
                </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="xyo">
              <Link to={{ pathname: "/dashboard/xyo" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img src={xyo} alt="xyo icon" class="token64 m-b-10" />
                    <div class="word-break" />
                    {xyobalance} XYO
                  </h3>
                </div>
              </Link>
            </div>
          </div>



          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="kick">
              <Link to={{ pathname: "/dashboard/kick" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={kick}
                      alt="kick icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {kickbalance} KICK
                  </h3>
              </div>
              </Link>
            </div>
          </div>

 </div>
          <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="nbr">
              <Link to={{ pathname: "/dashboard/nbr" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={nbr}
                      alt="nbr icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {nbrbalance} NBR
                  </h3>
                </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="bitrewards">
              <Link to={{ pathname: "/dashboard/bitrewards" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={bitrewards}
                      alt="bitrewards icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {bitrewardsbalance} BIT
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="ncash">
              <Link to={{ pathname: "/dashboard/ncash" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={ncash}
                      alt="ncash icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {ncashbalance} NCASH
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="essentia">
              <Link to={{ pathname: "/dashboard/essentia" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={essentia}
                      alt="essentia icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {essentiabalance} ESS
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="singularitynet">
              <Link to={{ pathname: "/dashboard/singularitynet" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={singularitynet}
                      alt="singularitynet icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {singularitynetbalance} AGI
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="incodium">
              <Link to={{ pathname: "/dashboard/incodium" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={incodium}
                      alt="incodium icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {incodiumbalance} INCO
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="autonio">
              <Link to={{ pathname: "/dashboard/autonio" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={autonio}
                      alt="autonio icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {autoniobalance} NIO
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="credits">
              <Link to={{ pathname: "/dashboard/credits" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={credits}
                      alt="credits icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {creditsbalance} CS
                  </h3>
              </div>
              </Link>
            </div>
          </div>


          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="dicet">
              <Link to={{ pathname: "/dashboard/dicet" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={dicet}
                      alt="dicet icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {dicebalance} CET
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="moneynet">
              <Link to={{ pathname: "/dashboard/moneynet" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={moneynet}
                      alt="moneynet icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {moneynetbalance} MNC
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="stacs">
              <Link to={{ pathname: "/dashboard/stacs" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={stacs}
                      alt="stacs icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {stacsbalance} STACS
                  </h3>
              </div>
              </Link>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card-box" id="orbs">
              <Link to={{ pathname: "/dashboard/orbs" }}>
                <div class="widget-detail-2">
                  <h3 class="m-b-0">
                    <img
                      src={orbs}
                      alt="orbs icon"
                      class="token64 m-b-10"
                    />
                    <div class="word-break" />
                    {orbsbalance} ORBS
                  </h3>
              </div>
              </Link>
            </div>
          </div>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/tokenpage.js